import { render } from "./MinimalistTemplate.vue?vue&type=template&id=1fda342d&scoped=true"
import script from "./MinimalistTemplate.vue?vue&type=script&lang=js"
export * from "./MinimalistTemplate.vue?vue&type=script&lang=js"

import "./MinimalistTemplate.vue?vue&type=style&index=0&id=1fda342d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fda342d"]])

export default __exports__